import React from 'react';
import { Link } from 'react-router-dom';
import { footerLinks, siteConfig } from '../../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-12">
          {/* Brand */}
          <div className="max-w-sm">
            <Link to="/" className="text-xl font-semibold text-white tracking-tight">
              {siteConfig.name}
            </Link>
            <p className="mt-4 text-white/60 text-sm leading-relaxed">
              {siteConfig.tagline}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-8 md:gap-16">
            <div>
              <h4 className="text-white font-medium text-sm mb-4">Legal</h4>
              <nav className="flex flex-col gap-3">
                {footerLinks.map((link) => (
                  <Link
                    key={link.label}
                    to={link.href}
                    className="text-white/60 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </div>

        {/* Compliance Notes */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="text-white/40 text-xs space-y-1">
              <p>{siteConfig.chargesDisclaimer}</p>
              <p>{siteConfig.cancellationNote}</p>
            </div>
            <p className="text-white/40 text-xs">
              © {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
